import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUser } from 'redux/actions/userActions';

export default () => {
  const dispatch = useDispatch();
  const authReducer = useSelector((state) => state.authReducer);
  const { isLogin } = authReducer;
  return useEffect(() => {
    if (isLogin) {
      dispatch(getUser());
    }
  }, [isLogin, dispatch]);
};
